module.exports = __webpack_public_path__ + "img/vpn.2907e1ca.png";